const LEFTSIDEBAR_ACTION_TYPES = {
  SIDEBAR_DATA: 'SIDEBAR_DATA',
  SIDEBAR_HEADER: 'SIDEBAR_HEADER',
  SIDEBAR_REQUEST_PAYLOAD: 'SIDEBAR_REQUEST_PAYLOAD',
  SET_DASHBOARD_REQUEST: 'SET_DASHBOARD_REQUEST',
  CHART_DATA: 'CHART_DATA',
  FETCH_REIMBURSEMENT_REQUEST: 'FETCH_REIMBURSEMENT_REQUEST',
  FETCH_REIMBURSEMENT_SUCCESS: 'FETCH_REIMBURSEMENT_SUCCESS',
  FETCH_PROVIDER_CREDITS: 'FETCH_PROVIDER_CREDITS',
  FETCH_PROVIDER_CREDITS_SUCCESS: 'FETCH_PROVIDER_CREDITS_SUCCESS',
  DOWNLOAD_CREDIT_REPORT: 'DOWNLOAD_CREDIT_REPORT',
};

export default LEFTSIDEBAR_ACTION_TYPES;
